
import blog from '@/mixins/blog'
import Nl2br from '~/mixins/nl2br.js'

export default {
  name: 'BlogListItem',
  mixins: [Nl2br, blog],
  props: {
    data: {
      type: Object,
      required: true
    },
    showType: {
      type: String,
      default: 'list'
    }
  },
  computed: {
    name () {
      return this.data.content?.seo?.title || this.data.name
    },
    summary () {
      return this.data.content?.blog_summary?.html
    },
    mobileImage () {
      return this.data.content?.blog_image?.filename
    },
    desktopImage () {
      return this.data.content?.blog_image_desktop?.filename
    }
  }
}
